export const Globe = ({ className = "", spin = false, slower = false }) => (
  <svg
    viewBox="0 0 200 200"
    aria-hidden="true"
    className={`${className} ${spin ? (slower ? "animate-spin-slower" : "animate-spin-slow") : ""}`}
  >
    <circle cx="100" cy="100" r="92" fill="none" stroke="currentColor" strokeWidth="2.2" />
    {[15, 55, 95, 135, 165].map((a) => (
      <ellipse
        key={a}
        cx="100"
        cy="100"
        rx="37"
        ry="92"
        transform={`rotate(${a} 100 100)`}
        fill="none"
        stroke="currentColor"
        strokeWidth="1.6"
      />
    ))}
    <ellipse cx="100" cy="100" rx="92" ry="37" fill="none" stroke="currentColor" strokeWidth="1.6" />
  </svg>
);
